import { CoasterFile } from '../core/doc/schema';

const INDEX_KEY = 'rcsim-coasters-index';
const entryKey = (id: string) => `rcsim-coaster:${id}`;

const ID_RE = /^[a-z0-9-_]{1,64}$/;

export function validCoasterId(id: string): boolean {
  return ID_RE.test(id);
}

export function listLocalCoasters(): { id: string; name: string }[] {
  try {
    const raw = localStorage.getItem(INDEX_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as { id: string; name: string }[];
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((item) => item && typeof item.id === 'string' && typeof item.name === 'string');
  } catch {
    return [];
  }
}

export function loadLocalCoaster(id: string): unknown | null {
  if (!validCoasterId(id)) return null;
  try {
    const raw = localStorage.getItem(entryKey(id));
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function saveLocalCoaster(id: string, file: CoasterFile): void {
  if (!validCoasterId(id)) throw new Error('invalid id');
  localStorage.setItem(entryKey(id), JSON.stringify(file));
  const name = file.meta?.name || id;
  const index = listLocalCoasters().filter((item) => item.id !== id);
  index.push({ id, name });
  index.sort((a, b) => a.name.localeCompare(b.name));
  localStorage.setItem(INDEX_KEY, JSON.stringify(index));
}

export function deleteLocalCoaster(id: string): boolean {
  if (!validCoasterId(id)) return false;
  const had = localStorage.getItem(entryKey(id)) !== null;
  localStorage.removeItem(entryKey(id));
  const index = listLocalCoasters().filter((item) => item.id !== id);
  localStorage.setItem(INDEX_KEY, JSON.stringify(index));
  return had;
}
